// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import WhoWeAre from './components/WhoWeAre';
import DownloadApp from './components/DownloadApp';
import './App.css'; // opcional: para @font-face o reset global
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div style={{ overflowX: 'hidden' }}>
        <Header />
        <Hero />
        <div id="about">
          <WhoWeAre />
        </div>
        <DownloadApp />
        <Testimonials />
        <Footer />
      </div>
      
    </Router>
  );
}

export default App;